import { Button, ButtonProps } from "antd";
import { useMemo } from "react";
import { useTranslate } from "#src/hooks";
import { useAntTheme } from "hooks/useAntTheme/";
import { SyncOutlined } from "@ant-design/icons";

export const CTAControls = ({
  showNextButton,
  showConfirmButton,
  showBackButton,
  showResetButton,
  showResetPhotoText,
  isNextLoading,
  isConfirmLoading,
  isNextDisabled,
  onNextClick,
  onConfirmClick,
  onBackClick,
  onResetClick,
}: {
  showNextButton: boolean;
  showConfirmButton: boolean;
  showBackButton: boolean;
  showResetButton: boolean;
  showResetPhotoText: boolean;
  isNextLoading?: boolean;
  isConfirmLoading?: boolean;
  isNextDisabled?: boolean;
  onNextClick: () => void;
  onConfirmClick: () => void;
  onBackClick: () => void;
  onResetClick: () => void;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  const resetText = useMemo(() => {
    return t(
      showResetPhotoText
        ? "src.components.ContactCloningMobile.camera.takeAnotherPhoto"
        : "src.components.ContactCloningMobile.voice.recordAgain"
    );
  }, [showResetPhotoText, t]);

  return (
    <>
      {showNextButton && (
        <MobileButton
          loading={isNextLoading}
          onClick={onNextClick}
          disabled={isNextDisabled || isNextLoading}
        >
          {t("buttons.next")}
        </MobileButton>
      )}
      {showConfirmButton && (
        <MobileButton
          loading={isConfirmLoading}
          onClick={onConfirmClick}
          disabled={isConfirmLoading}
        >
          {t("src.components.ContactCloningMobile.createContact")}
        </MobileButton>
      )}
      {showBackButton && (
        <MobileButton
          onClick={onBackClick}
          style={{
            backgroundColor: theme.colorTextBase,
            color: theme.colorBgBase,
          }}
        >
          {t("buttons.back")}
        </MobileButton>
      )}
      {showResetButton && (
        <MobileButton
          onClick={onResetClick}
          icon={<SyncOutlined style={{ fontSize: 22 }} />}
          style={{
            backgroundColor: theme.colorBgBase,
            color: theme.colorTextBase,
            borderColor: theme.colorBorder,
            borderWidth: 1.5,
            boxShadow: "none",
          }}
        >
          {resetText}
        </MobileButton>
      )}
    </>
  );
};

const MobileButton = ({ ...props }: ButtonProps) => {
  return (
    <Button
      type="primary"
      size="large"
      shape="round"
      block
      {...props}
      style={{ height: 54, fontWeight: 500, ...props.style }}
    />
  );
};
